import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as accountActions from '../../actions/accountActions'

import AccountView from './AccountView';

class AccountPage extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      account: Object.assign({}, this.props.account),
      errors: {}
    };
  }

  componentWilReceivedProps(nextPeops) {
   if(this.props.account.id !== nextPeops.account.id){
     this.setState({aacount: Object.assign({}, nextPeops.account)});
   }
  }

  render () {
    return(
      <AccountView key={this.state.account.id} account={this.state.account} />
    );
  }
}

AccountPage.propTypes = {
  actions: PropTypes.object.isRequired,
  account: PropTypes.object.isRequired
};

function  getAccountById(accounts, id) {
  const account = accounts.filter(account => account.id === id);
  if(account) return account[0];
  return null;
}

function mapStateToProps(state, ownProps) {
  const accountId = ownProps.match.params.id;
  let account;
  if(accountId) account = getAccountById(state.accounts, accountId);
  return {
    account: account
  }
}

function matchDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(accountActions, dispatch)
  };
}

export default connect(mapStateToProps,matchDispatchToProps)(AccountPage);




// WEBPACK FOOTER //
// ./src/components/account/AccountPage.js